import React from 'react';

const HeaderSocials = () => {
    return (
        <div className="home__socials">
            <a 
                href="https://github.com/bramplatier" 
                className="home__social-link" 
                target="_blank" 
                rel="noopener noreferrer"
                title="GitHub"
                aria-label="GitHub"
            >
                <i className="fab fa-github"></i>
            </a>

            <a 
                href="https://www.linkedin.com/in/bram-platier/" 
                className="home__social-link" 
                target="_blank" 
                rel="noopener noreferrer"
                title="LinkedIn"
                aria-label="LinkedIn"
            >
                <i className="fab fa-linkedin"></i>
            </a>

            <a 
                href="https://www.instagram.com/bramplatier?igsh=eDAwNzVkNDRndnNx" 
                className="home__social-link" 
                target="_blank" 
                rel="noopener noreferrer"
                title="Instagram"
                aria-label="Instagram"
            >
                <i className="fab fa-instagram"></i>
            </a>
  
            <a 
                href="https://x.com/gekke_bram" 
                className="home__social-link" 
                target="_blank" 
                rel="noopener noreferrer"
                title="Twitter"
                aria-label="Twitter"
            >
                <i className="fab fa-twitter"></i>
            </a>
        </div>
    );
};

export default HeaderSocials;
